import Rest2 from '../Services/Rest2'
import {store} from '../store/store'
/**
 * @typedef {PublisherService}
 */
export default class PublisherService{

    constructor() {
        this.resource = "/publisher"
        this.http = Rest2.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    getAll(){
        return this.http.get('/all');
    }

    getOne(product_id){
        return this.http.get(`/${product_id}`)    
    }
    
}